<template>
  <WdsStack justify-space-between align-center class="tw-grow">
    <WdsText large>
      <template #default><slot name="label" /></template>
      <template #subText>
        <span class="tw-text-base"><slot name="sub-label" /></span>
      </template>
    </WdsText>
    <slot v-if="props.readOnly" name="read-only" />
    <slot v-else />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack, WdsText } from '@worksome/wds-components'

interface Props {
  readOnly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  readOnly: false,
})
</script>
